import { useEffect, useCallback } from "react";
import { Sidebar as PrimeReactSidebar } from "primereact/sidebar";

// Wrapper de Sidebar que corrige el comportamiento de ESC:
// Si hay un overlay abierto (dropdown, datepicker, multiselect),
// el primer ESC cierra el overlay y el segundo cierra el sidebar.
export default function Sidebar({ visible, onHide, children, ...props }) {
  const handleEsc = useCallback(
    (e) => {
      if (e.key !== "Escape" || !visible) return;

      const overlayOpen = document.querySelector(
        ".p-dropdown-panel, .p-datepicker, .p-multiselect-panel, .p-cascadeselect-panel"
      );

      if (!overlayOpen) {
        onHide(e);
      }
    },
    [visible, onHide]
  );

  useEffect(() => {
    if (!visible) return;
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [visible, handleEsc]);

  return (
    <PrimeReactSidebar
      visible={visible}
      onHide={onHide}
      closeOnEscape={false}
      {...props}
    >
      {children}
    </PrimeReactSidebar>
  );
}
